import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)


// for using add class lazy to img, div or iframe and add data-img-src/phone/table/x2 attributes with urls

let imgSize = 'data-img-src'
if (window.innerWidth <= 600) {
    imgSize = 'data-img-phone'
} else if (window.innerWidth <= 1000) {
    imgSize = 'data-img-tablet'
} else if (window.innerWidth > 2000) {
    imgSize = 'data-img-x2'
}


// global function for using in popups or after ajax
export function loadElementLazyImage(elements) {
    elements.each(function () {
        let imgSrc = this.getAttribute(imgSize)
        if (!imgSrc) { imgSrc = this.getAttribute('data-img-src') }

        if (!this.classList.contains('loaded') && imgSrc) {
            let nodName = this['nodeName']
            let position = this.getAttribute('data-img-position')
            if (!position) position = 'center'

            if (nodName !== 'IMG' && nodName !== 'IFRAME' && nodName !== 'VIDEO') {
                this.style.background = 'url(' + imgSrc + ') no-repeat ' + position
                this.style.backgroundSize = 'cover'
            } else {
                if (nodName === 'VIDEO') {
                    this.querySelector('source').setAttribute('src', imgSrc)
                    this.load()
                } else {
                    this.setAttribute('src', imgSrc)
                }
            }

            this.classList.add('loaded')
        }

    })
}

export function loadBlockLazyImages($block){
    loadElementLazyImage($block.find('.lazy'))
}


export function initLazyLoad() {
    // load lazy images and iframes
    document.querySelectorAll('.lazy').forEach(function (el) {
        ScrollTrigger.create({
            trigger: el,
            start: "top bottom+=400px", // el top, screen bottom
            once: true,
            onEnter: () => loadElementLazyImage($(el))
        });
    })

}

initLazyLoad()




